import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MessagesService } from '../../../../services/messages.service';
import { MessagesModel } from '../../../../models/ApiResponseModel';
import { AnnoucementModel } from '../../../../models/AnnoucementModel';
import { DashboardService } from '../../../../services/dashboard.service';
import { SubscriptionService } from '../../../../shared/services/subscription.service';
import { Utilities } from '../../../../Utilities';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SignalRService } from '../../../../services/signalr.service';
import { CurrencyPipe } from '@angular/common';
import { ClearNotificationModel } from '../../../../models/SignalrModel';
import { DxDataGridComponent } from '../../../../../../node_modules/devextreme-angular';


@Component({
  selector: 'app-annoucements',
  templateUrl: './annoucements.component.html',
  styleUrls: ['./annoucements.component.css']
})
export class AnnoucementsComponent implements OnInit, OnDestroy {

  public MessageList: AnnoucementModel[] = [];
  public AnnoucementModelList: AnnoucementModel[] = [];
  public AnnoucementModel: AnnoucementModel;
  popupVisible = false;
  private subscriptions: Subscription[] = [];
  @ViewChild("viewAnnouncementGrid") viewAnnouncementGrid: DxDataGridComponent;

  constructor(public messageService: MessagesService,
    public subscriptionService: SubscriptionService,
    private router: Router,
    private signalRService: SignalRService
  ) {
  }

  ngOnDestroy() {
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  ngOnInit() {
    this.subscriptions.push(this.subscriptionService.CommunityLotId$.subscribe(lotId => {
      if (lotId) {
        this.bindandPrepareAnnouncement(lotId);
      }
    }));
    this.subscriptions.push(this.signalRService.updateData$.subscribe(x => {
      if (x > 0) {
        if (this.router.url.includes('messages/0')) {
          this.bindAnnouncement(this.subscriptionService.CommunityLotId$.getValue()).subscribe(x => {
            this.prepareAnnouncementData(x);
          });
        }
      }
    }));

    this.subscriptions.push(this.signalRService.refreshGrids$.subscribe(x => {
      if (x) {
        this.bindandPrepareAnnouncement(this.subscriptionService.CommunityLotId$.getValue());
      }
    }));
  }

  private bindandPrepareAnnouncement(lotId: number) {
    this.bindAnnouncement(lotId).subscribe(x => {
      this.prepareAnnouncementData(x);
      let clearModel = new ClearNotificationModel();
      clearModel.CommunityLotId = lotId;
      clearModel.NotificationType = 1;
      this.signalRService.clearNotification$.next(clearModel);
    });
  }

  private bindAnnouncement(lotId: number) {
    return this.messageService.GetAnnoucementByCommunityLotId(lotId);
  }

  private prepareAnnouncementData(x: any) {
    if (x) {
      x.annoucement.forEach(element => {
        element.CreatedDate = Utilities.convertToStandardDateFormat(element.CreatedDateString);
      });
      this.AnnoucementModelList = x.annoucement;
    } else {
      this.AnnoucementModelList = [];
    }
  }
  showInfo(annoucement) {
    this.AnnoucementModel = annoucement.data;
    this.AnnoucementModel.CreatedDate = Utilities.convertToStandardDateFormat(annoucement.data.CreatedDateString);
    this.messageService.GetAnnoucementDetailsByAnnoucementId(this.subscriptionService.CommunityLotId$.getValue(), this.AnnoucementModel.AnnoucementId).subscribe(x => {
      if (x) {
        this.popupVisible = true;
        // x.annoucement.CreatedDate=Utilities.convertToStandardDateFormat( x.annoucement.CreatedDate);
        x.annoucement.forEach(element => {
          element.CreatedDate = Utilities.convertToStandardDateFormat(element.CreatedDateString);
        });
        this.MessageList = x.annoucement;
        this.updateCurrentAnnouncement();
      }
    });
  }

  public onShown(event: any) {
    if (this.viewAnnouncementGrid && this.viewAnnouncementGrid.instance) {
      this.viewAnnouncementGrid.instance.refresh();
    }
  }

  private updateCurrentAnnouncement() {
    let currentAnnouncement = this.AnnoucementModelList.find(x => x.AnnoucementId === this.AnnoucementModel.AnnoucementId);
    if (currentAnnouncement) {
      currentAnnouncement.Comment = this.MessageList[0].Comment;
      currentAnnouncement.CreatedDate = this.MessageList[0].CreatedDate;
      currentAnnouncement.DepartmentName = this.MessageList[0].DepartmentName;
      currentAnnouncement.FromUser = this.MessageList[0].FromUser;
      currentAnnouncement.Status = this.MessageList[0].Status;
      currentAnnouncement.Subject = this.MessageList[0].Subject;
    }
  }

  ClosePopup() {
    this.popupVisible = false;
  }

  public onTitleRendered(event: any) {
    Utilities.setTitleDxPopup(event);
  }

}


// WEBPACK FOOTER //
// ./src/app/modules/dashboard/messages/annoucements/annoucements.component.ts